<div class="setting-search" style="position: relative;">
    <app-search-inline (keywordChange)="filterDataSources($event)"></app-search-inline>
</div>

<div class="data-sources">
    <div *ngFor="let group of groupedDataSources">
        <div class="group-title" *ngIf="group.dataSources.length > 0">{{frontEndGroups[group.groupId]}}</div>
        <div class="source gutter" *ngFor="let source of group.dataSources; let i = index;" (click)="connectDataSource(source.id)" [attr.data-cy]="source.name">
            <div class="logo">
                <img [src]="source.logo" [alt]="source.name" />
            </div>
            <div class="name">
                {{source.name}}
            </div>
            <div class="secondary-title">
                <ng-container *ngIf="source.activated>0 && !dataSourceIdsRelyOnGmailImport.includes(source.id)">
                    <div style="cursor: pointer; display: flex; height: 26px; justify-content: center; align-items: center;" (click)="dataSourceDetail($event, source)"><div class="rb rb-icon-error" style="color: #E54E44; font-size: 22px; margin-right: 6px; margin-bottom: 2px" *ngIf="hasError(source)"> </div><div class="activated">{{source.activated}} Activated Accounts</div></div>
                </ng-container>
                <ng-container *ngIf="source.activated > 0 && dataSourceIdsRelyOnGmailImport.includes(source.id)">
                    {{source.activated}} Activated Accounts
                </ng-container>
                <ng-container *ngIf="source.activated==0">
                    No Activated Accounts
                </ng-container>
            </div>
        </div>
    </div>
</div>
